import MinervaMark from './MinervaMark';

interface HeaderProps {
  selectedSubject: string | null;
  onBackToSubjects: () => void;
  onToggleResourcesPanel?: () => void;
  showResourcesPanel?: boolean;
}

function HeaderStyles() {
  return (
    <style>{`
      .mv-header {
        position: relative;
        z-index: 100;
        background: rgba(11,17,24,0.7);
        backdrop-filter: blur(18px) saturate(120%);
        -webkit-backdrop-filter: blur(18px) saturate(120%);
        border-bottom: 1px solid var(--gilt-hair);
      }
      .mv-header-inner {
        display: flex;
        align-items: center;
        gap: 16px;
        padding: 14px 24px;
      }
      .mv-back {
        width: 38px; height: 38px;
        display: flex; align-items: center; justify-content: center;
        border: 1px solid var(--gilt-line);
        border-radius: 9px;
        background: transparent;
        color: var(--vellum-dim);
        cursor: pointer;
        font-size: 1.1rem;
        transition: border-color 0.2s, background 0.2s, color 0.2s, transform 0.12s cubic-bezier(0.16,1,0.3,1);
      }
      .mv-back:hover { border-color: var(--gilt); background: var(--gilt-dim); color: var(--vellum); }
      .mv-back:active { transform: scale(0.94); }
      .mv-brand { display: flex; align-items: center; gap: 12px; }
      .mv-brand-mark {
        display: flex; align-items: center; justify-content: center;
        transition: transform 0.4s cubic-bezier(0.16,1,0.3,1);
      }
      .mv-brand:hover .mv-brand-mark { transform: rotate(-4deg); }
      .mv-title {
        font-family: var(--font-display);
        font-size: 1.32rem;
        font-weight: 500;
        font-optical-sizing: auto;
        color: var(--vellum);
        letter-spacing: 0.01em;
        line-height: 1;
      }
      .mv-sub {
        font-family: var(--font-mono);
        font-size: 0.66rem;
        color: var(--vellum-faint);
        letter-spacing: 0.06em;
        text-transform: uppercase;
        margin-top: 3px;
      }
    `}</style>
  );
}

export default function Header({ selectedSubject, onBackToSubjects }: HeaderProps) {
  return (
    <header className="mv-header">
      <HeaderStyles />
      <div className="mv-header-inner">
        {selectedSubject && (
          <button className="mv-back" onClick={onBackToSubjects} aria-label="Volver a las asignaturas">
            <i className="ri-arrow-left-line" />
          </button>
        )}
        <div className="mv-brand">
          <span className="mv-brand-mark">
            <MinervaMark size={32} />
          </span>
          <div>
            <h1 className="mv-title">Minerva</h1>
            <p className="mv-sub">{selectedSubject ?? 'Asistente de estudio'}</p>
          </div>
        </div>
      </div>
    </header>
  );
}
